require('./material-icons/material-icons.css')



//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/material-icons.js
// module id = hAPP
// module chunks = 0